import React, { useEffect, useState } from "react";
import { Link,useLocation } from "react-router-dom";
import { FaTimes, FaArrowRight } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";
import schoolLogo from "../assets/PHOTO-2026-03-07-23-51-58.jpg";

export default function PopupModal() {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => {

  const navEntries = performance.getEntriesByType("navigation");

  if (
    location.pathname === "/" &&
    navEntries.length > 0 &&
    navEntries[0].type === "reload"
  ) {

    const timer = setTimeout(() => {
      setOpen(true);
    }, 600);

    return () => clearTimeout(timer);
  }

}, [location.pathname]);

  // ESC CLOSE
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") {
        setOpen(false);
      }
    };

    window.addEventListener("keydown", handleKey);

    return () => {
      window.removeEventListener("keydown", handleKey);
    };
  }, []);

  return (
    <AnimatePresence>

      {open && (

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
  className="fixed inset-0 z-[999999] flex items-center justify-center p-4 overflow-y-auto"
        >

          {/* BACKDROP */}

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setOpen(false)}
            className="absolute inset-0 bg-black/75 backdrop-blur-md"
          ></motion.div>

          {/* MODAL */}

          <motion.div
            initial={{
              opacity: 0,
              scale: 0.8,
              y: 40,
            }}
            animate={{
              opacity: 1,
              scale: 1,
              y: 0,
            }}
            exit={{
              opacity: 0,
              scale: 0.9,
            }}
            transition={{
              duration: 0.45,
            }}
className="relative z-20 w-full max-w-xl max-h-[90vh] overflow-y-auto rounded-[32px] bg-white shadow-[0_40px_120px_rgba(0,0,0,.45)]"          >

            {/* TOP RIBBON */}

            <div className="bg-gradient-to-r from-[#07294d] to-[#0b4b87] py-3 text-center">

              <p className="text-white text-sm font-semibold tracking-widest uppercase">

                🎓 Admissions Open • Session 2026–27

              </p>

            </div>

            {/* CLOSE */}

          <button
  onClick={() => setOpen(false)}
  type="button"
  className="absolute top-5 right-5 z-[999999] w-11 h-11 rounded-full bg-white text-[#07294d] shadow-xl flex items-center justify-center hover:bg-[#07294d] hover:text-white transition-all duration-300"
>
  <FaTimes />
</button>

            {/* DECORATION */}

            <div className="absolute -top-24 -right-24 w-56 h-56 rounded-full bg-blue-100 blur-3xl opacity-70"></div>

            <div className="absolute -bottom-20 -left-20 w-52 h-52 rounded-full bg-yellow-100 blur-3xl opacity-60"></div>

            {/* CONTENT */}

            <div className="relative px-8 pt-10 pb-8 text-center">

              {/* FLOATING LOGO */}

              <motion.div
                animate={{
                  y: [0, -8, 0],
                }}
                transition={{
                  duration: 3,
                  repeat: Infinity,
                }}
                className="flex justify-center mb-6"
              >

                <div className="relative">

                  <div className="absolute inset-0 rounded-full bg-[#d4af37]/30 blur-xl scale-110"></div>

                  <div className="relative w-28 h-28 md:w-36 md:h-36 rounded-full bg-white border-[6px] border-[#d4af37] shadow-[0_15px_50px_rgba(0,0,0,.2)] flex items-center justify-center">

                    <img
                      src={schoolLogo}
                      alt="School Logo"
                      className="w-20 h-20 md:w-24 md:h-24 object-contain"
                    />

                  </div>

                </div>

              </motion.div>

              <h2 className="text-3xl font-black text-[#07294d]">

                Cambridge International School

              </h2>

              <p className="text-gray-500 mt-2 text-lg">

                Nakodar, Punjab

              </p>

              <div className="w-24 h-1 bg-[#d4af37] rounded-full mx-auto my-8"></div>
                            {/* INFO CARD */}

              <motion.div
                initial={{ opacity: 0, y: 25 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 }}
                className="bg-gradient-to-r from-[#f8fbff] to-white border border-[#d4af37]/30 rounded-3xl p-7 shadow-lg"
              >

                <span className="inline-block px-4 py-2 rounded-full bg-[#07294d] text-white text-sm font-semibold">

                  Session 2025–26

                </span>

                <h3 className="text-2xl font-bold text-[#07294d] mt-5">

                  Academic Excellence & Results

                </h3>

                <p className="text-gray-600 leading-8 mt-4">

                  Explore our outstanding academic achievements,
                  excellent board results, student success stories,
                  modern learning environment and admission details.

                </p>

              </motion.div>

              {/* HIGHLIGHTS */}

              <div className="grid grid-cols-3 gap-4 mt-8">

                <div className="rounded-2xl bg-[#f8fbff] p-4 shadow text-center">

                  <h4 className="text-2xl font-black text-[#07294d]">
                    100%
                  </h4>

                  <p className="text-sm text-gray-500 mt-1">
                    Results
                  </p>

                </div>

                <div className="rounded-2xl bg-[#f8fbff] p-4 shadow text-center">

                  <h4 className="text-2xl font-black text-[#07294d]">
                    1000+
                  </h4>

                  <p className="text-sm text-gray-500 mt-1">
                    Students
                  </p>

                </div>

                <div className="rounded-2xl bg-[#f8fbff] p-4 shadow text-center">

                  <h4 className="text-2xl font-black text-[#07294d]">
                    A+
                  </h4>

                  <p className="text-sm text-gray-500 mt-1">
                    Learning
                  </p>

                </div>

              </div>

              {/* BUTTONS */}

              <div className="flex flex-col sm:flex-row gap-4 justify-center mt-10">

                <Link
                  to="/public-disclosure"
                  onClick={() => setOpen(false)}
                  className="flex items-center justify-center gap-3 bg-[#07294d] hover:bg-[#0b3d6d] text-white px-8 py-4 rounded-xl font-semibold transition duration-300"
                >

                  View Details

                  <FaArrowRight />

                </Link>

                <Link
                  to="/admission-form"
                  onClick={() => setOpen(false)}
                  className="flex items-center justify-center gap-3 border-2 border-[#d4af37] text-[#07294d] hover:bg-[#d4af37] px-8 py-4 rounded-xl font-semibold transition duration-300"
                >

                  Apply Now

                </Link>

              </div>
                            {/* FOOTER */}

              <div className="mt-10 pt-6 border-t border-gray-200">

                <p className="text-sm text-gray-500">

                  Empowering Young Minds • Inspiring Bright Futures

                </p>

                <p className="mt-2 text-[#07294d] font-semibold">

                  Cambridge International School, Nakodar

                </p>

              </div>

            </div>

          </motion.div>

        </motion.div>

      )}

    </AnimatePresence>

  );
}